import PropTypes from 'prop-types';
var propTypes = {
  action: PropTypes.node,
  i18n: PropTypes.shape({
    close: PropTypes.string.isRequired
  }),
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onClose: PropTypes.func,
  pauseTimeoutOnHover: PropTypes.bool,
  subtitle: PropTypes.string,
  text: PropTypes.string.isRequired,
  timeout: PropTypes.number,
  type: PropTypes.oneOf(['help', 'informative', 'negative', 'positive', 'warning'])
};
export default propTypes;